import { render, staticRenderFns } from "./NewsCardContent.vue?vue&type=template&id=0e9139e8&scoped=true&"
import script from "./NewsCardContent.vue?vue&type=script&lang=js&"
export * from "./NewsCardContent.vue?vue&type=script&lang=js&"
import style0 from "./NewsCardContent.vue?vue&type=style&index=0&id=0e9139e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9139e8",
  null
  
)

export default component.exports